import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import { PRODUCT_CONFIG } from "../config/productConfig.js";

const ClosedAlphaLaunchPage = observer(() => {
  const { t, language } = useTranslation();
  const date = new Intl.DateTimeFormat(language, { dateStyle: "long" })
    .format(new Date(PRODUCT_CONFIG.alphaLaunchDate));
  return (
    <article className="landing-page landing-article">
      <Link className="landing-text-link" to="/news">{t("landing.launch.back")}</Link>
      <header>
        <p className="landing-eyebrow">{t("landing.launch.eyebrow")}</p>
        <h1>{t("landing.launch.title")}</h1>
        <p className="landing-article-meta"><time dateTime={PRODUCT_CONFIG.alphaLaunchDate}>{date}</time></p>
        <p className="landing-article-deck">{t("landing.launch.excerpt")}</p>
      </header>
      <div className="landing-article-copy">
        <p>{t("landing.launch.intro")}</p>
        <h2>{t("landing.launch.availableTitle")}</h2>
        <p>{t("landing.launch.availableBody")}</p>
        <h2>{t("landing.launch.testingTitle")}</h2>
        <p>{t("landing.launch.testingBody")}</p>
        <h2>{t("landing.launch.nextTitle")}</h2>
        <p>{t("landing.launch.nextBody")}</p>
        <blockquote>{t("landing.launch.quote")}</blockquote>
      </div>
      <div className="landing-actions">
        <Link className="landing-primary-action" to={PRODUCT_CONFIG.loginPath}>{t("landing.launch.enter")}</Link>
        <Link className="landing-secondary-action" to="/roadmap">{t("landing.launch.roadmap")}</Link>
      </div>
    </article>
  );
});

export default ClosedAlphaLaunchPage;
